import { connect } from "react-redux";
import {
  setDisableAutomatedSendModalOpen,
  setEnableAutomatedSendModalOpen,
  setConnectedService,
  setConnectServicesError,
} from "../../Header/actions/creators";
import ConnectServices from "./ConnectServices";

const mapStateToProps = (state) => ({
  listingUuid: state.tdpDetailsReducer.uuid,
  transactionType: state.tdpDetailsReducer.headerDetails?.type,
  connectedService: state.tdpDetailsReducer.connectedService,
  connectServicesError: state.tdpDetailsReducer.connectServicesError,
  clients: state.tdpPeopleReducer.people?.listing_clients,
  clientRoles: state.tdpPeopleReducer.completeRoleList || [],
});

const mapDispatchToProps = (dispatch) => ({
  openDisableAutomatedSendModal: () => dispatch(setDisableAutomatedSendModalOpen(true)),
  openEnableAutomatedSendModal: () => dispatch(setEnableAutomatedSendModalOpen(true)),
  setConnectedService: (connectedService) => dispatch(setConnectedService(connectedService)),
  setConnectServicesError: (hasError) => dispatch(setConnectServicesError(hasError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectServices);
